<div class="container">
  <ids-icon class="close_icon" size="L" (click)="endJourneyNative()">fechar</ids-icon>
  <div class="title-header">
    <span class="title" role="heading" aria-level="1">{{data.cpTituloNivel_1}}</span>
    <span class="sub-title" role="heading" aria-level="2"
      >{{data.cpTituloNivel_2}}</span
    >
  </div>
  <div class="ids-grid-2 content-cards" >
    <app-card-basic
    *ngFor="let card  of data.cpHighLightButtons"
      [icon]="card.icone"
      [title]="card.texto"
      [accessible_text]="card.textoAcessivel"
      (buttonEvent)="redirecionarNativoION(card)"
    ></app-card-basic>
   
  </div>
</div>
